"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitForSensorEventValueType = void 0;
const AssetSensorEventValueType_1 = __importDefault(require("../AssetSensor/AssetSensorEventValueType"));
function getUnitForSensorEventValueType(evt) {
    switch (evt) {
        case AssetSensorEventValueType_1.default.TEMPERATURE:
            return '°C';
        case AssetSensorEventValueType_1.default.HUMIDITY:
            return '%';
        case AssetSensorEventValueType_1.default.PROXIMITY_DETECTION:
            return '';
        case AssetSensorEventValueType_1.default.WATER_DETECTION:
            return '';
    }
}
exports.getUnitForSensorEventValueType = getUnitForSensorEventValueType;
exports.default = getUnitForSensorEventValueType;
